import {
  VuexModule,
  Module,
  Mutation,
  getModule,
} from "vuex-module-decorators";
import store from "@/store";
import { Compliance } from "@smeetz/compliance-common";
import type {
  Compliance as ComplianceV2,
  FiscalReceipt,
} from "@smeetz/compliance-common-v2";
import { IComplianceState } from "@/interfaces/store/ICompliance";
@Module({ dynamic: true, namespaced: true, store, name: "Compliance" })
class ComplianceMod extends VuexModule implements IComplianceState {
  public compliance: Compliance | null = null;
  /**
   * compliance-common-v2 instance (order session v2, France only — FIS-517).
   * Coexists with the v1 instance above: v1 keeps serving the events that are
   * not yet covered by the v2 package (see FIS-486).
   */
  public complianceV2: ComplianceV2 | null = null;
  /**
   * Fiscal receipt proof (fiscal number + signature) returned by the v2 SALE
   * event, keyed by order session id, so receipt printing can pick it up.
   */
  public fiscalReceipts: Record<string, FiscalReceipt> = {};
  public transactionNumber = 1;
  public complianceStatus = {
    packageInit: true,
    efrConnection: true,
    fdmConnection: true,
  };

  @Mutation
  setComplianceObj(data: { compliance: Compliance }) {
    const { compliance } = data;
    this.compliance = compliance;
  }

  @Mutation
  setComplianceV2Obj(data: { complianceV2: ComplianceV2 }) {
    this.complianceV2 = data.complianceV2;
  }

  @Mutation
  setFiscalReceipt(data: { orderSessionId: string; receipt: FiscalReceipt }) {
    this.fiscalReceipts[data.orderSessionId] = data.receipt;
  }

  @Mutation
  removeFiscalReceipt(orderSessionId: string) {
    delete this.fiscalReceipts[orderSessionId];
  }

  @Mutation
  increaseTransactionNumber() {
    this.transactionNumber++;
  }

  @Mutation
  resetTransactionNumber() {
    this.transactionNumber = 1;
  }

  @Mutation
  setComplianceStatus(data: {
    packageInit?: boolean;
    efrConnection?: boolean;
    fdmConnection?: boolean;
  }) {
    if (data.packageInit !== undefined) {
      this.complianceStatus.packageInit = data.packageInit;
    }
    if (data.efrConnection !== undefined) {
      this.complianceStatus.efrConnection = data.efrConnection;
    }
    if (data.fdmConnection !== undefined) {
      this.complianceStatus.fdmConnection = data.fdmConnection;
    }
  }

  /**
   * Resotres compliance module fields saved in localstorage
   */
  @Mutation
  restore(complianceFields: Partial<IComplianceState>) {
    const { transactionNumber } = complianceFields;
    if (transactionNumber) {
      this.transactionNumber = transactionNumber;
    }
  }
}

const ComplianceModule = getModule(ComplianceMod);
export default ComplianceModule;
